<div class="row justify-content-center">
    <div class="col-auto">
        <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
            <span class="material-symbols-outlined">health_and_safety</span>
            <h1 class="h4">Gestión de <strong class="fw-semibold text-colonial">Coberturas</strong></h1>
        </div>
        <p class="text-muted mx-auto text-center" style="max-width: 520px;">Visualiza, crea y edita el catálogo de
            coberturas.</p>
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-12 col-xl-10">
        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">list</span>
                    <span>Coberturas</span>
                </h3>
                <div class="d-flex align-items-center gap-3">
                    <button (click)="openCreateModal()"
                        class="btn bg-colonial btn-secondary d-flex align-items-center gap-1" type="button">
                        <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
                        Nueva
                    </button>
                </div>
            </div>
            <shared-table-container>
                <shared-table [headers]="tableHeaders" [items]="filteredCoverages" (endSearching)="onSearch($event)"
                    searchPlaceholder="Buscar coberturas" title="Coberturas">

                    <ng-template let-id="id" sharedTableColumn="actions">
                        <button (click)="$event.stopPropagation(); openEditModal(id)"
                            class="btn btn-sm btn-outline-secondary" type="button">
                            <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                        </button>
                    </ng-template>

                </shared-table>
            </shared-table-container>
        </div>
    </div>
</div>

<app-coverage-modal [isVisible]="showCoverageModal" [coverage]="selectedCoverage"
    (closed)="onCoverageModalClosed($event)">
</app-coverage-modal>